(function(){
    angular.module('tmx-app').factory('TradeRepositoryService', ['tmxResource','$q','lookupService','cacheStore', '$mdMedia',
        function(tmxResource,$q,lookupService,cacheStore,$mdMedia){
            var applications = tmxResource("Transaction");
            var vm = this;
            vm.tenant= APP_CONSTANTS.tenant;
            vm.BVSVerified = false;
            var vitasTenants = ["vitas","vitas-leb","vitas-eg"];
            vm.fullNameColumnhide = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? true : false;
            vm.fullNameColumnshow = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? false : true;
            var lebTranslationModelMapping = {
                "FirstName":"FirstName", "MiddleName":"FatherName","LastName":"LastName", "MotherName":"MotherName","EnglishName":"EnglishName",
                "CdrFirstName":"CDRFirstName","CdrFatherName":"CDRFatherName","CdrFamilyName":"CDRFamilyName","CdrMotherName":"CDRMotherName",
                "MotherFamilyName":"MotherFamilyName","CdrMotherFamilyName":"CDRMotherFamilyName"
            };

            applications.lebTranslationModelMapping = lebTranslationModelMapping;
            applications.fetchPendingTransaction = function(existingApp) {
                return applications.getByAction("SearchFromPendingTransaction", false,'put',existingApp);
            }

            applications.getTabEntityMapping = function() {
                if(cacheStore.get("TabEntityMapping")) {
                    return cacheStore.get("TabEntityMapping");
                }
                else {
                    return  tmxResource("Entity").getByAction("TabEntityMapping/", true, 'get').then(function(response) {
                        cacheStore.set("TabEntityMapping", angular.copy(response.data));
                    });
                }                        
            }

            applications.searchApplicationByNumber = function(applicationNumber) {
                return applications.getByAction("GetApplicationsByApplicationNumber/"+applicationNumber, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.data.forEach(item=>{
                            if(item['TmxCustomerMaster'].length > 0) {
                                item['CustomerName'] = item['TmxCustomerMaster'][0]['CustomerName'];
                                item['CustomerCode'] = item['TmxCustomerMaster'][0]['CustomerCode'] == null?'N/A': item['TmxCustomerMaster'][0]['CustomerCode'];
                            }
                            else {
                                item['CustomerName'] = 'N/A';
                                item['CustomerCode'] = 'N/A';
                            }                                                    
                        })
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.searchApplicationbyParams = function(param, ProductId) {
                return applications.getByAction("SearchSecondaryApprovedApps/"+ProductId+"/"+param, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.getExistingApplicationDetails = function(existingApp) {
                return applications.getByAction("GetExistingApplicationDetails", false,'post',existingApp);
            }

            applications.fetchEcib = function(obj) {
                return  tmxResource("Integration").getByAction("GeteCIBData", false, 'post',obj);
            }

            applications.getEligibility = function(obj) {
                return applications.getByAction("getEligibility",false,'post',obj);
            }

            applications.CancelById = function(transactionId) {
                return  applications.getByAction("CancelById/"+transactionId, false, 'put',{});
            }

            applications.getWorkflowStatesByProductId = function (ProductId) {
                return applications.getByAction("WorkflowStates/" + ProductId, true);
            };

            applications.getChecklistHistory = function (applicationId, productChecklistId) {
                return applications.getByAction("GetChecklistHistory/" + applicationId + "/" + productChecklistId, true);
            };

            applications.getTimeFrames = function(){
             
                return applications.getByAction("GetTimeFrameParameterForReport",false);
            };

            applications.postImage = function(obj){
             
                return applications.getByAction("UploadFile",false,'post',obj);
            };

            applications.reassignApplication = function(array) {
                return applications.getByAction("BulkReassignTask",false,'put',array);
            }

            applications.getloanappjobstatus = function(){
             
                return applications.getByAction("PostLoanApplicationStatus",false);
            };

            applications.initiateWorkflow = function(data){
             
                return applications.getByAction("InitiateWF",false,'put',data);
            };

            applications.getEcibDetail = function(){
                return tmxResource("enquiry/GeteCIBData").getById("3520268380749",true);

            }
            applications.createNewTransaction = function(data){
                return applications.getByAction("Create",false,'post',data);
            }

            applications.getApplicationById = function(id){
                tmxResource("LoanApplication").getById(id).then(function(response){                 
                    return response;
                });
            }

            applications.deleteById = function(id) {
                var deferred = $q.defer();
                tmxResource("LoanApplication").getById(id).then(function(result) {
                    deferred.resolve(result.$remove());
                });
                return deferred.promise;
            };

            applications.setApplicationState = function(data){
                return  tmxResource("Transaction").getByAction("SetApplicationState", false, 'put',data);
            }

            var loanAppSearchGridStatus =[] ;
            lookupService.getLoanApplicationStatusLkp().then(function(LoanApplicationStatus){
                LoanApplicationStatus.forEach(function(loanAppStatusLookup) {
                    loanAppSearchGridStatus.push({
                        "HiddenValue":loanAppStatusLookup.HiddenValue,
                        "VisibleValue":loanAppStatusLookup.VisibleValue
                    });
                });
            });

            applications.searchGridColumns = [      
                {
                    field: "Select",
                    title: "Select",
                    type: "text",
                    headerTemplate: "{{'Select' | translate}}",
                    template: "<input type='radio' ng-click='LoanApplicationAddCtrl.applicationSelectChange(dataItem)' id='application' name='application' ng-checked='dataItem.LoanApplicationId == LoanApplicationAddCtrl.selectedApplicationId && LoanApplicationAddCtrl.selectedApplicationId'>",
                },
                {
                    field: "TransactionNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    headerTemplate: "{{'ApplicationNumber' | translate}}"
                },
                {
                    field:"ClientReferenceNumber",
                    title: "TransactionID",
                    type: "text",
                    headerTemplate: "{{'TransactionID' | translate}}"
                },
                {
                    field: "ProductName",
                    title: "LoanProduct",
                    type: "text",
                    headerTemplate: "{{'ProductName' | translate}}"             
                },
                {
                    field: "ClientReferenceNumber",
                    title: "ClientReferenceNumber",
                    type: "text",
                    headerTemplate: "{{'ClientReferenceNumber' | translate}}"
                },
                {
                    field: "CustomerName",
                    title: "CustomerName",
                    type: "text",
                    headerTemplate: "{{'CustomerName' | translate}}"
                },
                {
                    field: "CustomerCode",
                    title: "CustomerCode",
                    type: "text",
                    headerTemplate: "{{'CustomerCode' | translate}}"
                },
                {
                    field: "ApplicationStatusLkp",
                    title: "ApplicationStatusLkp",
                    type: "text",
                    template: "{{LoanApplicationAddCtrl.getVisibleValueByLookupId(dataItem.ApplicationStatusLkp)}}",
                    headerTemplate: "{{'Status' | translate}}"
                }
            
            ];

            applications.gridColumns = [
                {
                    field:"TransactionNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('TransactionNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"TransactionNumber\")' ></i></span>"
                },
                {
                    field:"ClientReferenceNumber",
                    title: "TransactionID",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ClientReferenceNumber')}\" >{{'TransactionID' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>"
                },
                {
                    field:"CustomerName",
                    title: "Customer",
                    type: "alpha",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "<div>{{dataItem.CustomerName | defaultValue}} </div><span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span>",
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Customer Number", // CNIC. To be changed with integration values
                    type: "numeric",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ClientReferenceNumber')}\" >{{'CustomerNumber' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>",
                    //template: "<span class='nowrap'>{{TradeRepositoryCtrl.formatCNICNumber(dataItem) | cnic}}</span>"

                },
                {
                    field:"ProductName",
                    title:"Product",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"BranchName",
                    title:"Branch",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('BranchName')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"CreatorName",
                    title:"Creator",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('CreatorName')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"CreatorName\")' ></i></span>",
                    template:"<div>{{dataItem.CreatorName}}</div><span class='subtitle-wrap '>{{ dataItem.Creator }}</span>",   
                },
                {
                    field:"InboxName",
                    title:"Assigned To",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('InboxName')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"InboxName\")' ></i></span>",
                    template:"<div>{{dataItem.InboxName}}</div><span class='subtitle-wrap '>{{ dataItem.InboxUser }}</span>",                  
                },            
                {
                    field:"TransactionDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    template: "<span >{{dataItem.formattedTransactionDate}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('TransactionDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"TransactionDate\")' ></i></span>"
                }, //
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
                },
                {
                    template: "<md-menu flex='none' class='menu-list-item' md-position-mode=\"target-right target\" md-offset='-20 60'>"
                                    +"<md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>"
                                        +"<md-menu-content width='2' >"
                                            +"<md-menu-item><md-button ng-disabled='!TradeRepositoryCtrl.deletePermission' aria-label='del' class='tmxMin'  ng-click='TradeRepositoryCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Cancel</md-button></md-menu-item>"
                                            +"<md-menu-item><md-button ng-disabled='!TradeRepositoryCtrl.assignPermission' aria-label='del' class='tmxMin'  ng-click='TradeRepositoryCtrl.clickAssign(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>assignment</md-icon>Assign</md-button></md-menu-item>"
                                        +"</md-menu-content>"
                                +"</md-menu>",
                }
            ];
            applications.cols = [

                {
                    field:"TransactionNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('TransactionNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"TransactionNumber\")' ></i></span>"

                },
                {
                    field:"ClientReferenceNumber",
                    title: "TransactionID",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ClientReferenceNumber')}\" >{{'TransactionID' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ClientReferenceNumber\")' ></i></span>"
                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "numeric",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "{{dataItem.CustomerName}} "

                
                },
                {
                    field:"NationalIdentifierValue",
                    title: "CustomerNumber",
                    type: "numeric",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('NationalIdentifierValue')}\" >{{'CustomerNumber' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    //template: "{{TradeRepositoryCtrl.formatCNICNumber(dataItem)}} "


                },
                {
                    field:"ProductName",
                    title:"Product",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"ProductName\")' ></i></span>"

                },
            // {
            //     field:"ApprovedLoanAmount",
            //     title:"Amount",
            //     type: "integer",
            //     search: true,
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('RequestedLoanAmount')}\" >Amount<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"RequestedLoanAmount\")' ></i></span>"
            // },
            // {
            //     field:"TotalTenure",
            //     title:"Tenure",
            //     type: "select",
            //     search: true,
            //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('TotalTenure')}\" >Tenure<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"TotalTenure\")' ></i></span>"
            // },
                // {
                //     field:"BranchName",
                //     title:"LoanBranch ",
                //     type:"text",
                //     search: true,
                //     headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('BranchName')}\" >{{'LoanBranch' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"BranchName\")' ></i></span>"
                // },
                {
                    field:"Creator",
                    title:"Creator",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"Creator\")' ></i></span>"
                },
                {
                    field:"InboxUser",
                    title:"InboxUser",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"InboxUser\")' ></i></span>"
                },            
                {
                    field:"TransactionDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    applySearchRangeForThisDate:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active':TradeRepositoryCtrl.isFiltered('TransactionDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"TransactionDate\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                //search: true,
                    isNumber: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : TradeRepositoryCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='TradeRepositoryCtrl.isFiltered(\"Status\")' ></i></span>"
                }
            ];

            applications.ecibCols = [
                {
                    field: "MRDate",
                    title: "MRDate",
                    headerTemplate: "<span>{{'MRDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.MRDate)}}</p>"
                },
                {
                    field: "FDate",
                    title: "FDate",
                    headerTemplate: "<span>{{'FDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.FDate)}}</p>"
                }
                ,
                {
                    field: "AsOfDate",
                    title: "AsOfDate",
                    headerTemplate: "<span>{{'AsOfDate' | translate}}</span>",
                    template:
                "<p>{{LoanApplicationAddCtrl.formatDate(dataItem.AsOfDate)}}</p>"
                },
                {
                    field: "Balance",
                    title: "Balance",
                    headerTemplate: "<span>{{'Balance' | translate}}</span>",
                    template:"<p>{{dataItem.Balance}}</p>"
                },
                {
                    field: "Limit",
                    title: "Limit",
                    headerTemplate: "<span>{{'Limit' | translate}}</span>",
                    template:"<p>{{dataItem.Limit}}</p>"
                },
                {
                    field: "Product",
                    title: "Product",
                    headerTemplate: "<span>{{'Product' | translate}}</span>",
                    template:"<p>{{dataItem.Product}}</p>"
                },
                {
                    field: "IsDefaulter",
                    title: "IsDefaulter",
                    headerTemplate: "<span>{{'IsDefaulter' | translate}}</span>",
                    template:"<p>{{dataItem.IsDefaulter}}</p>"
                },
                {
                    field: "TermLoanOrEvergreen",
                    title: "TermLoanOrEvergreen",
                    headerTemplate: "<span>{{'TermLoanOrEvergreen' | translate}}</span>",
                    template:"<p>{{dataItem.TermLoanOrEvergreen}}</p>"
                },
                {
                    field: "TypeOfLoan",
                    title: "TypeOfLoan",
                    headerTemplate: "<span>{{'TypeOfLoan' | translate}}</span>",
                    template:"<p>{{dataItem.TypeOfLoan}}</p>"
                },
                {
                    field: "Bank",
                    title: "Bank",
                    headerTemplate: "<span>{{'Bank' | translate}}</span>",
                    template:"<p>{{dataItem.Bank}}</p>"
                },
                {
                    field: "ProductName",
                    title: "ProductName",
                    headerTemplate: "<span>{{'ProductName' | translate}}</span>",
                    template:"<p>{{dataItem.ProductName}}</p>"
                },
                {
                    field: "PositionAsOf",
                    title: "PositionAsOf",
                    headerTemplate: "<span>{{'PositionAsOf' | translate}}</span>",
                    template:"<p>{{LoanApplicationAddCtrl.formatDate(dataItem.PositionAsOf)}}</p>"
                },
                {
                    field: "WriteOff",
                    title: "WriteOff",
                    headerTemplate: "<span>{{'WriteOff' | translate}}</span>",
                    template:"<p>{{dataItem.WriteOff}}</p>"
                },
                {
                    field: "DateOfWriteOff",
                    title: "DateOfWriteOff",
                    headerTemplate: "<span>{{'DateOfWriteOff' | translate}}</span>",
                    template:"<p>{{LoanApplicationAddCtrl.formatDate(dataItem.DateOfWriteOff)}}</p>"
                }
      
                ,
                {
                    field: "Overdue30Plus",
                    title: "Overdue30Plus",
                    headerTemplate: "<span>{{'Overdue30Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue30Plus}}</p>"
                }
                ,
                {
                    field: "Overdue60Plus",
                    title: "Overdue60Plus",
                    headerTemplate: "<span>{{'Overdue60Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue60Plus}}</p>"
                }
                ,
                {
                    field: "Overdue90Plus",
                    title: "Overdue90Plus",
                    headerTemplate: "<span>{{'Overdue90Plus' | translate}}</span>",
                    template:"<p>{{dataItem.Overdue90Plus}}</p>"
                }
                ,
                {
                    field: "Overdue90Plus",
                    title: "WriteOff",
                    headerTemplate: "<span>{{'WriteOff' | translate}}</span>",
                    template:"<p>{{dataItem.WriteOff}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy30Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy30Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy30Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy30Plus}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy60Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy60Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy60Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy60Plus}}</p>"
                }
                ,
                {
                    field: "NoOfTimeAccountWentIntoOverdueBy90Plus",
                    title: "NoOfTimeAccountWentIntoOverdueBy90Plus",
                    headerTemplate: "<span>{{'NoOfTimeAccountWentIntoOverdueBy90Plus' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimeAccountWentIntoOverdueBy90Plus}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy1To15Days",
                    title: "NoOfTimesPaymentWereMadeLateBy1To15Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy1To15Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy1To15Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy16To20Days",
                    title: "NoOfTimesPaymentWereMadeLateBy16To20Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy16To20Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy16To20Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy21To29Days",
                    title: "NoOfTimesPaymentWereMadeLateBy21To29Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy21To29Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy21To29Days}}</p>"
                },
                {
                    field: "NoOfTimesPaymentWereMadeLateBy30Days",
                    title: "NoOfTimesPaymentWereMadeLateBy30Days",
                    headerTemplate: "<span>{{'NoOfTimesPaymentWereMadeLateBy30Days' | translate}}</span>",
                    template:"<p>{{dataItem.NoOfTimesPaymentWereMadeLateBy30Days}}</p>"
                }    
            ];


            return applications;

        }]);
})();